import { sarViews, inputNames } from "../../constants";
export default {
  [sarViews.FORM]: [{
    schema: {
      type: 'Input',
      settings: {
        fieldName: inputNames.FIRST_NAME,
        required: true
      }
    },
    configuration: {
      name: 'First Name Input',
      settings: {
        labelValue: 'First Name'
      }
    }
  }, {
    schema: {
      type: 'Input',
      settings: {
        fieldName: inputNames.LAST_NAME,
        required: true
      }
    },
    configuration: {
      name: 'Last Name Input',
      settings: {
        labelValue: 'Last Name',
        required: true
      }
    }
  }, {
    schema: {
      type: 'Input',
      settings: {
        fieldName: inputNames.EMAIL,
        required: true
      }
    },
    configuration: {
      name: 'Email Input',
      settings: {
        labelValue: 'Email',
        required: true
      }
    }
  }, {
    schema: {
      type: 'SubmitButton'
    },
    configuration: {
      text: 'Submit'
    }
  }],
  [sarViews.error.VERIFICATION]: [{
    schema: {
      type: 'TextArea',
      settings: {
        fieldName: 'customerMessage'
      }
    },
    configuration: {
      name: 'Customer Message Textarea',
      settings: {
        labelValue: ''
      }
    }
  }, {
    schema: {
      type: 'SubmitButton'
    }
  }],
  [sarViews.error.MAX_REQUESTS]: [{
    schema: {
      type: 'TextArea',
      settings: {
        fieldName: 'customerMessage'
      }
    },
    configuration: {
      name: 'Customer Message Textarea',
      settings: {
        labelValue: ''
      }
    }
  }, {
    schema: {
      type: 'SubmitButton'
    }
  }],
  [sarViews.error.ACTIVE_REQUEST]: [{
    schema: {
      type: 'TextArea',
      settings: {
        fieldName: 'customerMessage'
      }
    },
    configuration: {
      name: 'Customer Message Textarea',
      settings: {
        labelValue: ''
      }
    }
  }, {
    schema: {
      type: 'SubmitButton'
    },
    configuration: {
      name: 'Customer Message Textarea'
    }
  }]
};